export default {"src":"/_next/static/media/logo.0911ce81.svg","height":48,"width":76,"blurWidth":0,"blurHeight":0};